<template>
    <div>
        <div v-if="errors" v-html="errors" class="alert alert-danger" role="alert"></div>

        <div v-if="(!errors && !loading && (total_items == 0))" class="alert alert-warning" role="alert">
            {{ $root.text(
                'There are no {folders} that match your selection',
                { folders: $root.text($root.contents.folders_title, null, false, 'folders_title') },
                true
            ) }}
        </div>
        <div v-if="(total_items > 0)" class="card">
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table table-centered table-hover">
                        <thead class="thead-light">
                            <tr>
                                <th scope="col">
                                    <div class="row">
                                        <div class="col-1">{{ $root.text('Sort', null, true) }}</div>
                                        <div class="col-4">
                                            {{ $root.text(
                                                '{folder} name',
                                                {
                                                    folder: $root.text(
                                                        $root.contents.folder_title,
                                                        null,
                                                        false,
                                                        'folder_title'
                                                    )
                                                },
                                                true
                                            ) }}
                                        </div>
                                        <div class="col-2">
                                            {{ $root.text(
                                                $root.contents.subfolders_title,
                                                null,
                                                true,
                                                'subfolders_title'
                                            ) }}
                                        </div>
                                        <div class="col-4">{{ $root.text('Custom fields', null, true) }}</div>
                                        <div class="col-1">&nbsp;</div>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <draggable
                            v-model="items"
                            ghost-class="vue-drag-ghost"
                            handle=".drag-handle"
                            tag="tbody"
                            @end="onDragSortEnd"
                            animation="200"
                        >
                            <tr v-for="item in items" :key="item.id">
                                <td scope="row" :id="'folder-row' + item.id" class="pb-0">
                                    <div class="row">
                                        <div class="col-1 font-size-18 contact-links">
                                            <a
                                                href="#"
                                                class="drag-handle"
                                                style="cursor: move"
                                                v-b-tooltip.hover
                                                :title="$root.text('Re-order', null, true)"
                                                @click.prevent="doNothing()"
                                            >
                                                <i class="fas fa-arrow-down-arrow-up"></i>
                                            </a>
                                        </div>
                                        <div class="col-4" style="padding-top: 3px">
                                            <h5 class="font-size-14 mb-0">
                                                <a href="#" class="text-dark" @click.prevent="toggleEditFolder(item)">
                                                    {{ item.name }}
                                                </a>
                                            </h5>
                                        </div>
                                        <div class="col-2" style="padding-top: 3px">
                                            <span v-if="item.subfolder_info">
                                                {{ item.subfolder_info }}
                                            </span>
                                            <span v-else><loading :align="'left'" :size="1"></loading></span>
                                        </div>
                                        <div class="col-4" style="padding-top: 2px">
                                            <span v-if="item.custom_field_info" v-html="item.custom_field_info"></span>
                                            <span v-else style="margin-top: 1px">
                                                <loading :align="'left'" :size="1"></loading>
                                            </span>
                                        </div>
                                        <div class="col-1 font-size-18 contact-links">
                                            <a
                                                href="#"
                                                class="float-right"
                                                @click.prevent="toggleEditFolder(item)"
                                            >
                                                <span
                                                    v-if="(folder_details_open.indexOf(item.id) < 0)"
                                                    :key="'close-' + item.id"
                                                >
                                                    <i class="fa-regular fa-chevron-circle-down"></i>
                                                </span>
                                                <span v-else :key="'open-' + item.id">
                                                    <i class="fa-regular fa-chevron-circle-up"></i>
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="row list-details-td mt-2">
                                        <div class="col-12 list-details" :id="'folder-details' + item.id">
                                            <folder-edit-form
                                                :data="item"
                                                :list_component="thisComponent()"
                                            ></folder-edit-form>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </draggable>
                    </table>
                </div>
            </div>
        </div>

        <div style="position: relative; top: -20px; height: 40px; overflow: visible">
            <loading v-if="loading"></loading>
        </div>

        <div
            class="modal fade"
            id="subfolder-add-form-modal"
            data-backdrop="static"
            data-keyboard="false"
            tabindex="-1"
            aria-labelledby="subfolder-add-form-modal-label"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-scrollable">
                <subfolder-add-form></subfolder-add-form>
            </div>
        </div>

        <div
            class="modal fade"
            id="folder-delete-modal"
            data-backdrop="static"
            data-keyboard="false"
            tabindex="-1"
            aria-labelledby="folder-delete-modal-label"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-scrollable">
                <folder-delete></folder-delete>
            </div>
        </div>

        <div
            class="modal fade"
            id="folder-archive-modal"
            data-backdrop="static"
            data-keyboard="false"
            tabindex="-1"
            aria-labelledby="folder-archive-modal-label"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-scrollable" style="transition: max-width .35s ease">
                <folder-archive></folder-archive>
            </div>
        </div>

        <div
            class="modal fade"
            id="subfolder-delete-modal"
            data-backdrop="static"
            data-keyboard="false"
            tabindex="-1"
            aria-labelledby="subfolder-delete-modal-label"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-scrollable">
                <subfolder-delete></subfolder-delete>
            </div>
        </div>

        <div
            class="modal fade"
            id="subfolder-archive-modal"
            data-backdrop="static"
            data-keyboard="false"
            tabindex="-1"
            aria-labelledby="subfolder-archive-modal-label"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-scrollable" style="transition: max-width .35s ease">
                <subfolder-archive></subfolder-archive>
            </div>
        </div>

        <div
            class="modal fade"
            id="subfolder-de-archive-modal"
            data-backdrop="static"
            data-keyboard="false"
            tabindex="-1"
            aria-labelledby="subfolder-de-archive-modal-label"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-scrollable">
                <subfolder-de-archive></subfolder-de-archive>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import debounce from 'lodash/debounce';
    export default {
        components: {
            draggable,
        },
        data () {
            return {
                component_name: 'folders',
                loading: false,
                errors: false,
                items: [],
                total_items: 0,
                current_page: 1,
                last_page: 1,
                folder_details_open: []
            }
        },
        created() {
            this.handleDebouncedScroll = debounce(this.handleScroll, 100);
            window.addEventListener('scroll', this.handleDebouncedScroll);
        },
        mounted () {
            $('body').removeClass('login-body');
            this.getFolders();
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleDebouncedScroll);
        },
        methods: {
            thisComponent: function () {
                return this;
            },
            handleScroll(event) {
                if ((this.current_page < this.last_page) && !this.loading) {
                    const pageScrollTop = $('html, body').scrollTop();
                    const appHeight = $('#app').outerHeight();
                    const windowHeight = $(window).height();
                    const scrollPosition = appHeight - (pageScrollTop + windowHeight);
                    if (scrollPosition < 200) {
                        this.getFolders(this.current_page + 1);
                    }
                }
            },
            getFolders: function (page = 1) {
                if (!this.$root.hasPermission('assets_manage_folders')) {
                    this.errors = this.$root.text('Sorry, you do not have access to this function.', null, true);

                    return false;
                }
                if (this.loading || (page < 1) || ((page > 1) && (page <= this.current_page))) {
                    return false;
                }
                this.current_page = page;
                this.loading = true;
                this.errors = false;

                if (page == 1) {
                    this.items = [];
                    this.total_items = 0;
                    this.current_page = 1;
                    this.last_page = 1;
                    this.folder_details_open = [];
                }

                /**
                 * Send request to API
                 */
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id
                    + '/folders/!archived?page=' + page;
                var vm = this;

                axios({
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    vm.total_items = response.data.folders.total;
                    vm.current_page = response.data.folders.current_page;
                    vm.last_page = response.data.folders.last_page;
                    response.data.folders.data.forEach((item, index) => {
                        delete item.sort_order;
                        item.subfolder_info = null;
                        vm.items.push(item);
                    });
                })
                .catch(function (error) {
                    vm.errors = vm.$root.text('Something went wrong, please try again', null, true);
                    if (error.response.status == 401) {
                        // missing/lost API token - logout user
                        vm.$root.doLogout();
                    }
                    if (error.response.data.error) {
                        vm.errors = error.response.data.error;
                    }
                })
                .finally(() => {
                    vm.loading = false;
                });
            },
            toggleEditFolder: function (folder) {
                if (this.folder_details_open.indexOf(folder.id) < 0) {
                    this.folder_details_open.push(folder.id);
                    $('#folder-row' + folder.id).addClass('highlighted');
                    $('#folder-details' + folder.id).slideDown('slow');
                } else {
                    var vm = this;
                    $('#folder-details' + folder.id).slideUp('slow', function () {
                        $('#folder-row' + folder.id).removeClass('highlighted');
                        for (var n = 0; n < vm.folder_details_open.length; n++) { 
                            if (vm.folder_details_open[n] == folder.id) { 
                                vm.folder_details_open.splice(n, 1); 
                            }
                        }
                    });
                }
            },
            onDragSortEnd: function(event) {
                if (event.newIndex == event.oldIndex) {
                    return false;
                }
                this.errors = false;
                /**
                 * Send move folder request to API
                 */
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/folder/'
                    + this.items[event.newIndex].id + '/move';
                const data = {
                    sort_order: event.newIndex
                };
                var vm = this;

                axios({
                    method: 'put',
                    url: url,
                    data: data,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    vm.$root.folders_changed = true;
                })
                .catch(function (error) {
                    if (error.response.status == 401) {
                        // missing/lost API token - logout user
                        vm.$root.doLogout();
                    }
                    if (error.response.data.error) {
                        vm.errors = error.response.data.error;
                    }
                });
            },
            doNothing: function () {
                return null;
            }
        }
    }
</script>
